module.exports = __webpack_public_path__ + "static/riley-j-ewing-resume-adc0b8772c99f34c3a6f93de6f06b1ff.pdf";